// Error codes we want to intercept and allow the UI to display as form validation errors without a toast.
const INTERCEPT_ERROR_CODES = ['email_taken', 'username_taken', 'unique_identifier_combination'];
/**
 *  For errors that are API errors but presented as form errors
 *  When validating fields that are handled by an integration API through our own endpoints
 *  We ignore the toast
 * @param {Array} errors
 * @example
 * {
 *   "data": null,
 *   "meta": null,
 *   "errors": [
 *     {
 *       "message": "This username is already taken.",
 *       "source": {
 *         "path": [
 *           "username"
 *         ],
 *         "field": "username"
 *       },
 *       "code": "username_taken",
 *       "retryable": null,
 *       "meta": null
 *     }
 *   ]
 * }
 */
export const presentAsFormError = (errors) => {
  const code = errors[0]?.code;
  return INTERCEPT_ERROR_CODES.includes(code);
};
